import {
  ResultsRowMetadata,
  ResultsTable,
  ResultsTableMetadata,
} from 'notebook/integrations/results/ResultsTableConstants';
import {ACTION_SUBMIT_RESULTS_ROWS} from 'notebook/store/VersioningConstants';
import makeSubmitRowActionFunction, {
  getRowAwareLoadingMessage,
  RowSubmissionRange,
} from 'notebook/structured-tables/action-functions/makeSubmitRowActionFunction';
import {
  ActionResultType,
  performServerSideTableWriteActionWithAudits,
} from 'notebook/structured-tables/action-functions/PerformActionFunctions';
import {doPerformCreateResults} from 'notebook/structured-tables/action-functions/submitResultsActionFunction';
import * as ActionFunctionDAO from 'notebook/structured-tables/ActionFunctionDAO';
import {AxisContextMenuActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';

import invokeStructuredTableMappings from '../structured-table-mappings/invokeStructuredTableMappings';

export const SUBMIT_RESULT_ROW_ACTION_FUNCTION_CONFIG = {
  allowOutsideOfEntry: false,
  onSelectForSubmit: async (
    actionFunctionParams: AxisContextMenuActionFunctionParameters<ResultsTableMetadata, ResultsRowMetadata>
  ): Promise<void> => {
    const entryId = actionFunctionParams.entryOrTemplateId!;
    const structuredTable = actionFunctionParams.structuredTable as ResultsTable;
    const selection: RowSubmissionRange = {
      start: actionFunctionParams.selectionRange!.minIndex,
      end: actionFunctionParams.selectionRange!.maxIndex + 1,
    };

    await performServerSideTableWriteActionWithAudits<ActionFunctionDAO.ResultSubmitResponse>({
      entryId,
      loadingScreenMessage: getRowAwareLoadingMessage(
        selection,
        'Updating Results For Rows',
        'Updating Results For Row'
      ),
      autoSaverAction: ACTION_SUBMIT_RESULTS_ROWS,
      doPerformAction: ({updateStatus, dataModsHeader, allRowsSubmitted}) =>
        doPerformCreateResults(
          entryId,
          structuredTable,
          actionFunctionParams.computedTable,
          actionFunctionParams.actionFunctionContext,
          selection,
          updateStatus,
          dataModsHeader,
          allRowsSubmitted
        ),
      doPostRefresh: (actionResult) => {
        invokeStructuredTableMappings(
          entryId,
          structuredTable,
          actionResult.resultType === ActionResultType.PARTIAL_SUCCESS
            ? actionResult.submittedRange
            : selection
        );
        return Promise.resolve();
      },
      analyticsActionForPerfTracking: 'submit_results_structured_table_rows',
      structuredTables: [actionFunctionParams.structuredTable],
      structuredTableAdapters: [actionFunctionParams.structuredTableAdapter],
      computedTables: [actionFunctionParams.computedTable],
      tables: actionFunctionParams.table ? [actionFunctionParams.table] : [],
      selection,
    });
  },
};

export default makeSubmitRowActionFunction<ResultsTableMetadata, ResultsRowMetadata>(
  SUBMIT_RESULT_ROW_ACTION_FUNCTION_CONFIG
);
